define.alias("shared/components/shared/ui/switcher/item", "calendar/components/shared/ui/switcher/item");